import { ZERO } from "@utils/constants";
import { displayPrice } from "@utils/pricing";
import { Shopify } from "@models/shopify.model";
import LineItemPrice from "../line-item-price";
import * as StyledOrder from "../OrderSummary.styled";
import * as Styled from "./SubTotals.styled";

export interface SubTotalsProps {
  hasBundle: boolean;
  order: Shopify.Order;
  shadowPrices?: boolean;
  totalLineItemDiscounts: number;
  totalShippingDiscounts: number;
  totalOrderDiscounts: number;
}

const SubTotals = ({
  hasBundle,
  order,
  shadowPrices,
  totalLineItemDiscounts,
  totalShippingDiscounts,
  totalOrderDiscounts,
}: SubTotalsProps) => {
  const { subtotalPrice, totalShippingPrice, totalTax } = order;

  const subtotalFloat = parseFloat(subtotalPrice.amount);
  const subtotalFinal = subtotalFloat - totalLineItemDiscounts;
  const shippingFinal = parseFloat(totalShippingPrice.amount) - totalShippingDiscounts;

  return (
    <Styled.SubTotalsWrapper>
      <Styled.FlexWrapper>
        <StyledOrder.P>Subtotal</StyledOrder.P>
        <StyledOrder.PriceWrapper data-testid="subtotal">
          <LineItemPrice
            original={subtotalPrice.amount}
            // TO DO: MIR-1019: Only output subtotalFinal when custom order attributes are added.
            // final={subtotalFinal}
            final={hasBundle ? subtotalFloat : subtotalFinal}
            shadowPrices={shadowPrices}
          />
        </StyledOrder.PriceWrapper>
      </Styled.FlexWrapper>
      <Styled.FlexWrapper>
        <StyledOrder.P>Delivery</StyledOrder.P>
        <StyledOrder.PriceWrapper data-testid="shipping-total">
          <LineItemPrice
            original={totalShippingPrice.amount}
            final={shippingFinal}
            shadowPrices={shadowPrices}
            zeroDisplay={"FREE"}
          />
        </StyledOrder.PriceWrapper>
      </Styled.FlexWrapper>
      <Styled.FlexWrapper>
        <StyledOrder.P>Sales Tax</StyledOrder.P>
        <StyledOrder.PriceWrapper data-testid="tax-total">
          {shadowPrices ? ZERO : displayPrice(parseFloat(totalTax.amount))}
        </StyledOrder.PriceWrapper>
      </Styled.FlexWrapper>
      {/* // TO DO: MIR-741: Tackle Promotions specific to total order */}
      {totalOrderDiscounts > 0 && (
        <Styled.FlexWrapper>
          <StyledOrder.P>Discount</StyledOrder.P>
          <StyledOrder.PriceWrapper className="red">
            {shadowPrices ? ZERO : displayPrice(totalOrderDiscounts * -1, true)}
          </StyledOrder.PriceWrapper>
        </Styled.FlexWrapper>
      )}
    </Styled.SubTotalsWrapper>
  );
};
export default SubTotals;
